<template>
  <header class="mobile-navbar" role="navigation">
    <nav class="mobile-navbar__wrapper">
      <div class="mobile-navbar__row-one">
        <div>
          <button
            @click="$router.go(-1)"
            class="mobile-navbar__back-btn"
            :style="$route.name === 'home' ? 'visibility: hidden' : ''"
          >
            <i class="material-icons">arrow_back_ios</i>
          </button>
        </div>
        <div class="mobile-navbar__logo-wrapper">
          <router-link :to="{ name: 'home' }" replace>
            <img
              class="mobile-navbar__ine-logo"
              src="@/assets/images/home-logo.png"
              alt="INE Logo"
            />
          </router-link>
        </div>
        <Profile :isAuthenticated="isAuthenticated" :profile="profile" />
      </div>
      <div class="mobile-navbar__row-two">
        <div @click="showMobileSearch = false">
          <button
            class="mobile-navbar__mega-menu-btn"
            @click="toggleMegaMenu()"
          >
            Discover
            <i v-if="isMegaMenuShown" class="material-icons">arrow_drop_up</i>
            <i v-else class="material-icons">arrow_drop_down</i>
          </button>
        </div>
        <button
          @click="showMobileSearch = !showMobileSearch"
          class="mobile-navbar__search-icon"
        >
          <i class="material-icons">search</i>
        </button>
        <SearchForm
          v-if="showMobileSearch"
          @closed="showMobileSearch = false"
        />
      </div>
      <MegaMenu
        v-if="isMegaMenuShown"
        :primaryAreas="primaryAreas"
        :secondaryAreas="secondaryAreas"
        @closeMegaMenu="toggleMegaMenu"
      />
    </nav>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SearchForm from '@/components/forms/SearchForm.vue'
import MegaMenu from './MobileMegaMenu.vue'
import Profile from './Profile.vue'

export default {
  name: 'MobileNavBar',
  data() {
    return {
      showMobileSearch: false,
      isMegaMenuShown: false,
    }
  },
  methods: {
    toggleMegaMenu() {
      this.isMegaMenuShown = !this.isMegaMenuShown
    },
  },
  components: {
    SearchForm,
    MegaMenu,
    Profile,
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      profile: state => state.auth.userProfile,
    }),
    ...mapGetters({
      primaryAreas: 'learningAreas/primaryAreas',
      secondaryAreas: 'learningAreas/secondaryAreas',
    }),
  },
}
</script>

<style lang="scss">
.mobile-navbar {
  background-color: var(--black);
  z-index: 202;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  @include tablet {
    display: none;
  }
  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  &__row-one {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--dark-gray);
    padding: 7px 10px;
  }
  &__back-btn {
    background: transparent;
    border: none;
    color: var(--white);
    vertical-align: middle;
    &:hover {
      cursor: pointer;
    }
  }
  &__logo-wrapper {
    position: absolute;
    width: 100px;
    right: 0;
    left: 0;
    margin: 0 auto;
  }
  &__ine-logo {
    width: 100px;
  }
  &__row-two {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 15px;
    background-color: var(--light-gray);
    position: relative;
  }
  &__mega-menu-btn {
    background: transparent;
    color: var(--white);
    border: none;
    font-size: 1rem;
  }
  &__search-icon {
    position: absolute;
    right: 10px;
    color: var(--white);
    font-size: 1.4rem;
    background: transparent;
    border: none;
    @media screen and (max-width: 450px) {
      right: -4px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
